import './styles.css';
import React, {Component} from 'react';
import { Button } from 'packages/components';
import {sendGAEvent} from "../../../../utils/analytics";
import {decodeHTML5} from "../../../../actions/metrics";
import {NODE_RIBBONS, BUTTON_GROUP} from "./constants";
import store from '../../../../store';
import {setFromData} from "../../../../actions/navbar"
import { SetValueElementMouseEnter } from '../../../../components/PersistentMiniEpg/MiniObserver';
class RibbonCategories extends Component{
    constructor(props){
        super(props);
        this.parentScroll;
        this.state = {
            visibleItems: props.visibleItems
        }
        this.indexOfSelectedButton = -1;
        this.focusHandler = props.focusHandler;
        this.history = props.history;
        this.goToLink = this.goToLink.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);   
        this.handleKeyPress = this.handleKeyPress.bind(this);     
        this.ribbonIndex = props.index;
        this.someRibbonIsSelected = false;
        this.ribbonName = props.ribbonName;
        this.idsRibbonsUpAndDown = props.idsRibbonsUpAndDown
        this.isMusic = props.isMusic
        this.elementoConPuntero = false;
    }

    goToLink(uri, title){
      const resume = store.getState().navbar;
      store.dispatch(setFromData({
        ribbon_title : title,
      }));
      if(resume && resume.nodes && resume.nodes.length > 0) {
        const node = resume.nodes.find(node => this.history.location.pathname.includes(node.code));
        const _item = this.state.visibleItems.find(({item}) => item.href === uri).item;
        if(node && node.text && node.text !== '') {
          sendGAEvent({
            hitType: 'event',
            eventCategory: NODE_RIBBONS.replace('{{NODE_NAME}}', node.text),
            eventAction: decodeHTML5(BUTTON_GROUP),
            eventLabel: _item && _item.title ? _item.title : ''
          });
        }
      }
        this.history.push(uri);
    }

    handleOnClick(uri, title, id_rol){
        if (this.props.onClick && typeof this.props.onClick === 'function') this.props.onClick(id_rol, title);
        else this.goToLink(uri, title);
    }

    onFocus(event) {
        if(!this.elementoConPuntero){
            if(typeof this.focusHandler === 'function'){
                this.focusHandler(event);
            }
        }

        const visibleItems = this.state.visibleItems ? this.state.visibleItems : []
        const sizeVisibleItems = visibleItems.length;

        let element = event.target;
        const beforeSelected = document.querySelector(".last-selected");

        if(beforeSelected && sizeVisibleItems >= 5) beforeSelected.classList.remove("last-selected");
        if(sizeVisibleItems >= 5) element.classList.add("last-selected");
        //Se agrega un menos 10 para ajustar con el foco dinámico

        if(!this.elementoConPuntero){
          this.parentScroll.scrollLeft = element.offsetLeft - 12;
        } 
    }

    componentWillReceiveProps(nextProps){
        if(JSON.stringify(nextProps.visibleItems) !== JSON.stringify(this.state.visibleItems)){
            this.setState({visibleItems: nextProps.visibleItems});
        }
    }

    componentDidMount(){
        if(this.indexOfSelectedButton>-1){
            let element = this.parentScroll.children[this.indexOfSelectedButton];
            this.parentScroll.scrollLeft = element.offsetLeft - 12;
        }
        if(this.ribbonIndex === 0){
            window.SpatialNavigation.focus('.selected');
        }
        document.addEventListener('keydown', this.handleKeyPress);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyPress);
    }

    createDataSnDown(position, dataSnDown){
      const focus = this.idsRibbonsUpAndDown
                              && this.idsRibbonsUpAndDown[position]
                                ? this.idsRibbonsUpAndDown[position] : {};

      const { focusDown = null} = focus;

      return focusDown || dataSnDown;
    }

    handleMouseEnter() {
        this.elementoConPuntero = true;
    }

    handleMouseLeave() {
        this.elementoConPuntero = false;
    }

    handleKeyPress() {
        this.elementoConPuntero = false;
    }

    render(){
        const { history: { location: { pathname } } } = this.props;
        const thereAreSelected = this.state.visibleItems.some(({item}) => item.selected);
        return (
            <div className={`ribbon-items ribbon-categories ${pathname.includes('/mundial') ? 'mundial' : ''}`} ref={(el) => this.parentScroll = el}  onMouseEnter={()=>{this.handleMouseEnter()}} onMouseLeave={()=>{this.handleMouseLeave()}}>
                {
                    this.state.visibleItems.map((node, index) => {
                        const uri = node.item.href;
                        const title = node.item.title;
                        const key = `secondlevel-link-${index}`;
                        const variant = node.item.selected ? 'primary' : 'default';
                        const dataOptions = {};
                        const disableLeft = { "data-sn-left": '' };
                        const disableRight = { "data-sn-right": '' };
                        const { item: { dataSnUp = false, dataSnDown = false } = {}} = node;
                        let className = node.item.selected ? 'selected' : '';
                        this.someRibbonIsSelected = this.someRibbonIsSelected || node.item.selected;
                        console.log("this.idsRibbonsUpAndDown ", node )
                      if (this.ribbonIndex === 0 && index == 0 && !this.someRibbonIsSelected) {
                            className = 'selected';
                        }

                        if (dataSnUp) {
                            dataOptions['data-sn-up'] = dataSnUp;
                        }

                        if (dataSnDown) {
                            // position = "1" because there is a ribbon of superdestacados
                            dataOptions['data-sn-down'] = this.createDataSnDown("1", dataSnDown);
                        }else{
                          if(!thereAreSelected){
                            // position = "0" because there isn't a ribbon of superdestacados
                            dataOptions['data-sn-down'] = this.createDataSnDown("0", dataSnDown);
                          }
                        }

                        if(this.isMusic && this.idsRibbonsUpAndDown && this.idsRibbonsUpAndDown["1"]){
                          const { focusDown} = this.idsRibbonsUpAndDown["1"];
                          dataOptions['data-sn-down'] = focusDown;
                        }

                        this.indexOfSelectedButton = node.item.selected ? index : this.indexOfSelectedButton;

                        return (
                            <Button
                                id={key}
                                key={key}
                                type="button"
                                variant={variant}
                                onClick={()=>{this.handleOnClick(uri, title, node.item.id_rol)}}
                                onFocus={this.onFocus}
                                className={`focusable ${index === 0 ? "last-selected" : ""} ${className} ${title}`}
                                dataOptions={dataOptions}
                                blockedLeft={pathname.includes('/mundial2022_partidos') && index === 0 ? disableLeft : ''}
                                blockedRight={(pathname.includes('/mundial2022_partidos') && index === 3) || (index === this.state.visibleItems.length - 1) ? disableRight : ''}
                            >
                                <div
                                >
                                    {title}
                                </div>
                            </Button>
                        );
                    })
                }
            </div>
        );
    }
}

export default RibbonCategories;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonCategories/index.jsx